export const sleep = (ms: number = 40) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};